import React, { Component } from 'react'
import { Link } from 'react-router-dom'

import Button from '../../Components/Button/Button'
import Hero from '../../Components/Hero/Hero'
import Languages from '../../Components/Languages/Languages'
import OurTeam from '../../Components/OurTeam/OurTeam'
import QuoteCard from '../../Components/QuoteCard/QuoteCard'
import StackCard from '../../Components/StackCard/StackCard'
import SpecialtiesCard from '../../Components/Specialties/Specialties'
import SiteContainer from '../../Containers/SiteContainer/SiteContainer'

import './Home.css'

class HomePage extends Component {
  render() {
    return (
      <SiteContainer>
        <Hero title="We build apps & websites for startups">
          <div className="fmbm-hero__small-text wow pulse delay-2s">
            And other passionate makers like us!
          </div>
          <div className="fmbm-hero__cta">
            <Button
              href="https://goo.gl/forms/Ic1vg0nIpl8qfdi22"
              style={{ backgroundColor: '#02ded5' }}
              buttonText="Reach out"
            />
          </div>
        </Hero>
        <QuoteCard
          QuoteText={
            'For Makers by Makers, at its core, is a team of people who love to create.'
          }
        >
          <p>
            For Makers by Makers, at its core, is a team of people who love to
            create (“Makers”). We make things for ourselves, at our homes and at
            the office. We create because our curiosity leaves us no choice.
          </p>
          <p>
            That curiosity is what allows us to change the way companies of all
            shapes and sizes look at technology. Our clients range from
            technology companies with a reach of 500m annual consumers, to brand
            new StartUps.
          </p>
          <Link to={'/'} className={'fmbm-quote-card__contents-full-link'}>
            Learn More
          </Link>
        </QuoteCard>
        <StackCard />
        <OurTeam />
        <SpecialtiesCard />
        <Languages />
      </SiteContainer>
    )
  }
}

export default HomePage



// WEBPACK FOOTER //
// ./src/Pages/Home/HomePage.js